// /languages/de.ts
export default {
  lang: "Deutsch",

  // Dextra Content
  welcome: "Dextra Video-Beratung",
  s_services: "Dextra Serviceleistungen",
  s_tracking: "Service-Verfolgung",
  s_record: "Dokumentenservices",
  s_redirect: "Service-Umleitung",
  s_adress: "Adressservices",
  s_feedback: "Kundensupport",
  privacy: "Ihre Privatsphäre ist wichtig. Gespräche werden vertraulich behandelt und nicht aufgezeichnet.",
  privacy_ve: "Ihre Privatsphäre ist wichtig. Gespräche werden vertraulich behandelt und nicht aufgezeichnet.",
  ve_privacy: "Ihre Privatsphäre ist wichtig. Gespräche werden vertraulich behandelt und nicht aufgezeichnet.",
  agentAvailability: "Agent-Verfügbarkeit",
  available: "Verfügbar",
  unavailable: "Nicht verfügbar",
  connecting_title: "Verbinde...",
  connecting_message: "Bitte warten Sie einen Moment.",
  cancel: "Abbrechen",
  ve_cancel: "Abbrechen",
  button_start: "Hier starten",
  seconds: "Sekunden",
  
  // Agent status translations
  agent_online: "Agent Online",
  agent_available: "Agent ist verfügbar",
  services_title: "Unsere Services",
  
  // Media permissions
  mediaPermissions: {
    title: "Kamera und Mikrofon erforderlich",
    description: "Für die Video-Beratung benötigen wir Zugriff auf Ihre Kamera und Ihr Mikrofon. Bitte erlauben Sie den Zugriff, wenn Ihr Browser danach fragt.",
    cameraRequired: "Kamera für Video",
    microphoneRequired: "Mikrofon für Audio",
    allowAccess: "Zugriff erlauben",
    requesting: "Wird angefragt...",
    skip: "Überspringen",
    helpText: "Sie können die Berechtigungen später in Ihren Browser-Einstellungen ändern."
  }
};
